<template>
  <b-list-group-item>
    <b-row>
      <b-col cols="8">{{ orderline.name }}</b-col>
      <b-col class="orderdets-price">{{ item_price | toCurrency }}</b-col>
    </b-row>
    <b-row cols="1" class="orderdets-desc"><b-col>{{ orderline.description }}</b-col></b-row>
    <div class="orderdets-desc" v-for="option of orderline.options" :key="option.id">
      <b-row cols="1">
        <b-col v-if="option.choiceitems.length>0">
          {{ option.name }}:
          <span v-for="(choiceitem, index) of option.choiceitems" :key="choiceitem.id">
            <span v-if="index != 0">, </span><span>{{ choiceitem.name }}</span>
            <span v-if="option.add_price != 0"> {{ option.add_price | toCurrency }}</span>
            <span v-if="choiceitem.add_price != 0"> {{ choiceitem.add_price | toCurrency }}</span>
          </span>
        </b-col>
      </b-row>
    </div>
    <b-row cols="1" class="orderdets-desc"><b-col>{{ orderline.notes }}</b-col></b-row>
    <b-row cols="2">
      <b-col style="font-size: small;">Qty: {{ orderline.qty }}</b-col>
      <b-col class="orderdets-price">Total: {{ order_line_total | toCurrency }}</b-col>
    </b-row>
    <b-row class="sidebar-buttons">
      <b-col cols="2"><b-button pill size="sm" variant="outline-dark" :disabled="sb_spinner" @click="emitAdjustItem(orderline, 'remove')">-</b-button></b-col>
      <b-col cols="8" style="text-align: center;"><b-button pill size="sm" variant="outline-dark" :disabled="sb_spinner" @click="emitAdjustItem(orderline, 'edit')">Edit / Notes</b-button></b-col>
      <b-col cols="2"><b-button pill size="sm" variant="outline-dark" :disabled="sb_spinner" @click="emitAdjustItem(orderline, 'add')">+</b-button></b-col>
    </b-row>
  </b-list-group-item>
</template>

<script>
export default {
  name: 'OrderDetails',
  props: ['orderline', 'sb_spinner'],
  computed: {
    item_price: function() {
      return this.orderline.std_price + this.orderline.gcTopUpAmount
    },

    order_line_total: function () {
      var linetotal = 0;
      linetotal+=this.orderline.std_price;
      linetotal = this.orderline.gcCardNumber ? this.orderline.gcTopUpAmount : linetotal + this.orderline.gcTopUpAmount
      for (const option of this.orderline.options) {
        // find how many options been selected and multiple the price by that amount
        var optqty = option.choiceitems.length;
        linetotal+=(option.add_price*optqty);
        for (const choiceitem of option.choiceitems) {
          linetotal+=(choiceitem.add_price*1);
        }
      }
      linetotal*=this.orderline.qty;
      return linetotal;
    }
  },
  methods: {
    // adjusttype = 'add' - Add duplicate item with all options preset
    // adjusttype = 'edit' - Remove one quantity (remember options) and re-add with new options
    // adjusttype = 'remove' - Remove one from the quantity, remove item if qty = 1
    emitAdjustItem(orderline, adjustType) {
      this.$emit('emit-adjust-line', orderline, adjustType);
    },

    emitQtyUpdate(item, qty) {
      if (qty >= 1) {
        // this.orderitem.std_price = (this.orderitem.std_price/this.orderitem.qty)*qty;
        // this.orderitem.qty=qty;
        this.$emit('qtyemit', item, qty);
      } else if (qty === 0) {
        alert("Are you sure you want to remove the item?");
        this.$emit('removeemit', item);
      }
    }
  }
}
</script>

<style>

.orderdets-price {
  font-size: small;
  font-weight: bold;
  text-align: right;
}

.orderdets-desc {
  font-size: small;
  font-weight: 100;
}
</style>

})
